<template>
  <div>
    <div class="kk-subnav__header">
      <div class="kk-subnav__header-leftside">
        <div data-test-id="left-side-header-title">{{ title }}</div>
        <sort-options />
      </div>
      <div class="kk-subnav__header-toggle">
        <span class="icon-layout kk-subnav__header-icon"></span>
      </div>
    </div>
    <div v-if="isLoading" class="progress-bar">
      <div class="progress-bar-value"></div>
    </div>
  </div>
</template>

<script>
import SortOptions from "./SortOptions.vue";

export default {
  components: { SortOptions },
  props: ["title", "isLoading"],
};
</script>
<style lang="less" scoped>
@import "../../../assets/styles/variables";

.kk-subnav {
  &__header {
    padding: 0 0 0 20px;
    height: 50px;
    border-bottom: 3px solid #d7d7d7;
    color: @kk-color-primary-blue;
    display: flex;
    font-size: 18px;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    &-icon {
      font-size: 22px;
    }
    &-leftside {
      display: flex;
      flex: 1;
      padding-right: 0.5rem;
      justify-content: space-between;
      align-items: center;
    }
    &-toggle {
      height: 100%;
      border-left: 3px solid #d7d7d7;
      width: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: rgb(145, 174, 231);
      &:hover {
        color: @kk-color-light-blue;
      }
    }
  }
}
</style>
